import { render, staticRenderFns } from "./Backtest.vue?vue&type=template&id=829ec070&"
import script from "./Backtest.vue?vue&type=script&lang=js&"
export * from "./Backtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports